import { setPublishFailed } from '../../reducers/syi';
import * as imageActions from '../image-actions';

const handleInvalidImages = (errors, dispatch, translator) => {
    const displayTexts = [];
    let invalidImageCount = 0;
    errors.forEach((error) => {
        const invalidImageIds = error.message.split(',');
        invalidImageIds.forEach((id) => {
            dispatch(imageActions.removeImageWithId(id));
            // eslint-disable-next-line better-mutation/no-mutation
            invalidImageCount++;
        });
    });
    if (invalidImageCount > 0) {
        displayTexts.push(
            translator('syi_publish_error_invalid_image', {
                count: invalidImageCount
            })
        );
    }
    return displayTexts;
};

const translateErrorCode = (error, t) => {
    switch (error.errorCode) {
        case 'AlreadyPublished':
            return t('syi_publish_error_alreadypublished');
        case 'BuyItNowPriceNotLargerThanOpeningPrice':
            return t(
                'syi_publish_error_buyitnowpricenotlargerthanopeningprice'
            );
        case 'BuyItNowPriceNotLargerThanReservePrice':
            return t(
                'syi_publish_error_buyitnowpricenotlargerthanreserveprice'
            );
        case 'BuyItNowPriceTooLarge':
            return t('syi_publish_error_buyitnowpricetoolarge');
        case 'BuyItNowPriceUnset':
            return t('syi_publish_error_buyitnowpriceunset');
        case 'CampaignCodeInvalid':
            return t('syi_publish_error_campaigncodeinvalid');
        case 'CategoryContainsTooManyItems':
            return t('syi_publish_error_categorycontainstoomanyitems');
        case 'CategoryDoesNotSupportBin':
            return t('syi_publish_error_categorydoesnotsupportbin');
        case 'CategoryDoesNotSupportUsedItems':
            return t('syi_publish_error_categorydoesnotsupportuseditems');
        case 'CategoryIdUnknown':
            return t('syi_publish_error_categoryidunknown');
        case 'CustomEndDateTooLate':
            return t('syi_publish_error_customenddatetoolate');
        case 'CustomEndDateTooSoon':
            return t('syi_publish_error_customenddatetoosoon');
        case 'DisplayHighlightedCannotBeRemoved':
            return t('syi_publish_error_displayhighlightedcannotberemoved');
        case 'DisplayPromotedCannotBeRemoved':
            return t('syi_publish_error_displaypromotedcannotberemoved');
        case 'DurationGreaterThanUpperLimitWithUnsetCustomEndDate':
            return t(
                'syi_publish_error_durationgreaterthanupperlimitwithunsetcustomenddate'
            );
        case 'DurationNotAllowed':
            return t('syi_publish_error_durationnotallowed');
        case 'ImagesTooFew':
            return t('syi_publish_error_imagestoofew');
        case 'ImagesTooMany':
            return t('syi_publish_error_imagestoomany');
        case 'NoImageUploadedByUser':
            return t('syi_publish_error_noimageuploadedbyuser');
        case 'ItemHasBidsAndCannotBeChanged':
            return t('syi_publish_error_itemhasbidsandcannotbechanged');
        case 'LongDescriptionCannotBeEmpty':
            return t('syi_publish_error_longdescriptioncannotbeempty');
        case 'LongDescriptionTooLong':
            return t('syi_publish_error_longdescriptiontoolong');
        case 'MemberIsActiveInternationalBuyer':
            return t('syi_publish_error_memberisactiveinternationalbuyer');
        case 'MemberIsSuspended':
            return t('syi_publish_error_memberissuspended');
        case 'MemberNotAllowedToListImmeditateEndingItems':
            return t(
                'syi_publish_error_membernotallowedtolistimmeditateendingitems'
            );
        case 'OpeningPriceBelowOne':
            return t('syi_publish_error_openingpricebelowone');
        case 'OpeningPriceTooLarge':
            return t('syi_publish_error_openingpricetoolarge');
        case 'OwnReferenceTooLong':
            return t('syi_publish_error_ownreferencetoolong');
        case 'PriceBelowOne':
            return t('syi_publish_error_pricebelowone');
        case 'PriceBelowZero':
            return t('syi_publish_error_pricebelowzero');
        case 'ReservePriceNotLargerThanOpeningPrice':
            return t('syi_publish_error_reservepricenotlargerthanopeningprice');
        case 'ReservePriceTooLarge':
            return t('syi_publish_error_reservepricetoolarge');
        case 'ShippingCostBelowZero':
            return t('syi_publish_error_shippingcostbelowzero');
        case 'ShippingOptionsCannotBeEmpty':
            return t('syi_publish_error_shippingoptionscannotbeempty');
        case 'ShippingOptionsCountTooLarge':
            return t('syi_publish_error_shippingoptionscounttoolarge');
        case 'ShippingOptionsMoreThanOneWithTakeawayOnly':
            return t(
                'syi_publish_error_shippingoptionsmorethanonewithtakeawayonly'
            );
        case 'ShortDescriptionCannotBeEmpty':
            return t('syi_publish_error_shortdescriptioncannotbeempty');
        case 'ShortDescriptionTooLong':
            return t('syi_publish_error_shortdescriptiontoolong');
        case 'UnknownError':
            return t('syi_publish_error_unknownerror');
    }

    return error.message;
};

export const handleServerValidationError = (errors, dispatch, t) => {
    const invalidImageErrorCodes = ['DeletedImage', 'MissingImage'];
    const imageErrorFilter = (error) =>
        invalidImageErrorCodes.includes(error.errorCode);
    const nonImageErrorFilter = (error) =>
        !invalidImageErrorCodes.includes(error.errorCode);

    const imageErrors = errors.filter(imageErrorFilter);
    const nonImageErrors = errors.filter(nonImageErrorFilter);

    const imageErrorDisplayTexts = handleInvalidImages(
        imageErrors,
        dispatch,
        t
    );
    const nonImageErrorDisplayTexts = nonImageErrors.map((error) =>
        translateErrorCode(error, t)
    );

    const errorDisplayTexts = imageErrorDisplayTexts.concat(
        nonImageErrorDisplayTexts
    );
    const errorDisplayText = errorDisplayTexts.join(' ').trim();
    dispatch(setPublishFailed(errorDisplayText));
};
